import React from "react";

function Phone(props: React.PropsWithChildren) {
  return (
    <div className="relative box-content w-[375px] rounded-[54px] bg-black p-3">
      <div className="w-[375px] h-[790px] overflow-hidden rounded-[45px] bg-white text-black">
        {props.children}
      </div>
      <div className="pointer-events-none absolute top-[22px] left-0 flex w-full items-center justify-center">
        <div className="h-6 w-20 rounded-full bg-black"></div>
      </div>
      <div className="pointer-events-none absolute bottom-[27px] left-1/2 z-50 h-1 w-[120px] -translate-x-1/2 rounded-full bg-[#999]"></div>
    </div>
  );
}

export default Phone;
